import React, { useEffect, useRef, useState } from 'react'
import MyButton from '../../../../../components/UI/button/MyButton'
import GlassEffect from '../GlassEffect/GlassEffect'
import LandingVideo from '../LandingVideo/LandingVideo'
import useEnhancedEffect from '@mui/material/utils/useEnhancedEffect';

export default function ProLevelCard({ img, icon, text, handleClick, title, video, aspectRatio, source, isVisible, reverse, autoplay }) {

    const videoRef = useRef(null);




    const handleMouseEnter = () => {
        if (videoRef.current) {
            videoRef.current.play();
        }
    };

    const handleMouseLeave = () => {
        if (videoRef.current) {
            videoRef.current.pause();
            videoRef.current.currentTime = 0;
        }
    };

    useEffect(() => {
        if (videoRef.current) {
            if (autoplay) {
                videoRef.current.play();
            } else {
                videoRef.current.pause();
                // videoRef.current.currentTime = 0;
            }
        }
    }, [autoplay])


    const children = <div className={`landing-prolevel-card ${title ? 'landing-prolevel-card--center' : ''} ${reverse ? 'landing-prolevel-card--reverse' : ''}`} onMouseEnter={isVisible ? handleMouseEnter : null}
        onMouseLeave={isVisible ? handleMouseLeave : null}
        onClick={() => handleClick(source)}
    >
        {img && <div className="landing-prolevel-card__img">
            {video ? <LandingVideo

                videoRef={videoRef}
                aspectRatio={aspectRatio}
                imgSrc={`${process.env.REACT_APP_BASENAME}/img/${img}`}
                videoSrc={`${process.env.REACT_APP_BASENAME}/video/${video}`}

            /> :
                <img src={`${process.env.REACT_APP_BASENAME}/img/${img}`} alt="" />}
        </div>}

        <div className="landing-prolevel-card-info">
            {icon && <img src={`${process.env.REACT_APP_BASENAME}/img/${icon}`} alt='' />}
            {title && <h3>{title}</h3>}

            <p>{text}</p>
            <MyButton buttonText={'Try it'} buttonStatus={'white'} />
        </div>
    </div>
    return (
        <div className="landing-prolevel-card--3">
            <div className="landing-prolevel-card--2">
                <div className="landing-prolevel-card--1">
                    <div className="landing-prolevel-card--0">
                        <div className="landing-prolevel-card--final">
                            <GlassEffect children={children} className="stackCard" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}
